const apiURL = process.env.REACT_APP_API_URL;

export const authRequest = async (endpoint, payloadData) => {
  const config = {
    method: 'POST',
    body: JSON.stringify(payloadData),
    headers: { 'Content-Type': 'application/json' },
  };
  return window.fetch(`${apiURL}/auth/${endpoint}`, config).then(async (response) => {
    const data = await response.json();
    if (response.ok) {
      return data;
    }
    return Promise.reject(data);
  });
};
